import { createAction, props } from '@ngrx/store';
import { ISettingState } from './setting.state';

export const initSettingAction = createAction('[popup Setting] popup Setting');

export const setSettingAction = createAction(
  '[popup Setting] set data',
  props<ISettingState>()
);
